/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const mutations = {


    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
        state.isVerticalNavMenuActive = value
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val
    },
    UPDATE_MAIN_LAYOUT_TYPE(state, val) {
        state.mainLayoutType = val
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
        state.verticalNavMenuItemsMin = val
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
        state.verticalNavMenuWidth = width
    },

    // VxAutoSuggest
    UPDATE_STARRED_PAGE(state, payload) {

        // find item index in search list state
        const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url == payload.url)

        // update the main list
        state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.url == payload.url)

            // remove item using index
            state.starredPages.splice(index, 1)
        }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED(state, list) {
        const starredPagesMore = state.starredPages.slice(10)
        state.starredPages = list.concat(starredPagesMore)
    },
    ARRANGE_STARRED_PAGES_MORE(state, list) {
        let downToUp = false
        let lastItemInStarredLimited = state.starredPages[10]
        const starredPagesLimited = state.starredPages.slice(0, 10)
        state.starredPages = starredPagesLimited.concat(list)

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) downToUp = true
        })

        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited)
        }
    },


    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val
    },
    UPDATE_PRIMARY_COLOR(state, val) {
        state.themePrimaryColor = val
    },
    UPDATE_THEME(state, val) {
        state.theme = val
    },
    UPDATE_WINDOW_WIDTH(state, width) {
        state.windowWidth = width
    },
    UPDATE_WINDOW_SCROLL_Y(state, val) {
        state.scrollY = val
    },

    UPDATE_USER_INFO(state, val) {
        state.userInformation = val;
        localStorage.setItem('userInfo', JSON.stringify(val))
    },
    UPDATE_ORGANIZATION_SUCCESS(state, val) {
        state.isUpdateOrganization = val;
    },
    ORGANIZATION_UPDATE_INFO(state, val) {
        state.organizationUpdateInfo = val;
    },
    BRANCH_UPDATE_INFO(state, val) {
        state.branchUpdateInfo = val;
    },
    DELETE_BRANCH_STATUS(state, val) {
        state.deleteBranchStatus = val;
    },
    DELETE_CAMERA_STATUS(state, val) {
        state.deleteCameraStatus = val;
    },
    DELETE_CAMERA_GROUP_STATUS(state, val) {
        state.deleteCameraGroupStatus = val;
    },
    DELETE_WIFI_STATUS(state, val) {
        state.deleteWifiStatus = val;
    },
    DELETE_QR_CODE(state, val) {
        state.deleteQRCode = val;
    },
    DELETE_NEWS(state, val) {
        state.deleteNews = val;
    },
    DELETE_NOTIFY(state, val) {
        state.deleteNotification = val;
    },
    DELETE_MEETING_ROOM_STATUS(state, val) {
        state.deleteMeetingRoomStatus = val;
    },
    DELETE_MEETING_SCHEDULE_STATUS(state, val) {
        state.deleteMeetingScheduleStatus = val;
    },
    UPDATE_AI_RESTRICTED_SUCCESS(state, val) {
        state.isUpdateAIRestricted = val;
    },
    UPDATE_MASTER_WORK_SHIFT(state, val) {
        state.isUpdateMasterWorkShift = val;
    },
    UPDATE_ORGANIZATION_WORK_SHIFT(state, val) {
        state.isUpdateOrganizationWorkShift = val;
    },
    UPDATE_BRANCH_LIST_INFO(state, val) {
        localStorage.setItem('branchInfoList', JSON.stringify(val))
    },
    UPDATE_EMPLOYEE(state, val) {
        state.isUpdateEmployee = val;
    },
    UPDATE_DEVICE(state, val) {
        state.isUpdateDevice = val;
    },
    UPDATE_ASSIGNED_DEVICE(state, val) {
        state.isUpdateAssignedDevice = val;
    },
    UPDATE_LEAVE(state, val) {
        state.isUpdateLeave = val;
    },
    UPDATE_DEVICE_TOKEN(state, val) {
        localStorage.setItem('deviceToken', val)
    },
    UPDATE_DAILY_WORK_DETAIL(state, val) {
        state.isUpdateWorkDetail = val;
    },
    UPDATE_AREA_DETAIL(state, val) {
        state.isUpdateArea = val;
    },
    UPDATE_PLACE(state, val) {
        state.isUpdatePlace = val;
    },
    UPDATE_CAMERA(state, val) {
        state.isUpdateCamera = val;
    },
    UPDATE_VIP_CUSTOMER(state, val) {
        state.isUpdateVipCustomer = val;
    },
    UPDATE_DETECT_UNKNOWN(state, val) {
        state.isUpdateDetectUnknown = val;
    },
    CLOSE_POPUP_EMPLOYEE(state, val) {
        state.isClosePopupEmployee = val;
    },
    UPDATE_CHECKIN_CHECKOUT(state, val) {
        state.isUpdateCheckInCheckOut = val;
    },
    UPDATE_IN_OUT(state, val) {
        state.isUpdateInOut = val;
    },
    UPDATE_PERMISSION_SUCCESS(state, val) {
        state.isUpdatePermission = val;
    },
    UPDATE_FACE_RECOGNITION_REGISTER(state, val) {
        state.isUpdateFaceRecognitionRegister = val;
    },
    UPDATE_FACE_RECOGNITION(state, val) {
        state.isUpdateFaceRecognition = val;
    },
    UPDATE_ORG_PACKAGE(state, val) {
        state.isUpdateOrgPackage = val;
    },
    UPDATE_REQUEST_PACKAGE(state, val) {
        state.isUpdateOrgPackageRequestPackage = val;
    },
    RELOAD_DATA(state, val) {
        state.isReload = val;
    },
    DELETE_CLASS(state, val) {
        state.isDeleteClass = val
    },
    UPDATE_PERMISSION_INFO(state, val) {
        state.permissionsInfo = val;
    },
    UPDATE_CATEGORY(state, val) {
        state.isUpdateCategory = val;
    },
    UPDATE_BOOK(state, val) {
        state.isUpdateBook = val;
    },
    UPDATE_RECEIPTS(state, val) {
        state.isUpdateReceipts = val;
    },
    UPDATE_DOCUMENT(state, val) {
        state.isUpdateDocument = val;
    },
    DELETE_DEPARTMENT(state, val) {
        state.isDeleteDepartment = val;
    },
    UPDATE_STUDENT(state, val) {
        state.isUpdateStudent = val;
    },
    UPDATE_TEACHER_INTERACTION(state, val) {
        this.state.isUpdateTeacherInteraction = val
    },
    DELETE_FILE_EMPLOYEE(state, val) {
        this.state.isDeleteFileEmployee = val
    },
    DELETE_CATEGORY(state, val) {
        this.state.isDeleteCategory = val
    },
    DELETE_TOPICSET(state, val) {
        this.state.isDeleteTopicSet = val
    },
    UPDATE_QUESTION(state, val) {
        this.state.isUpdateQuestion = val
    },
    DELETE_QUESTION(state, val) {
        this.state.isDeleteQuestion = val
    },
    DELETE_FILE_EMPLOYEE_NOT_ID(state, val) {
        this.state.isDeleteFileNotId = val
    },
    UPDATE_EXAM(state,val){
        this.stata.isUpdateExam = val
    }
};

export default mutations

